const BREAKDOWN_URL = '/api/breakdown';

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export interface MorningCheckResponse {
  id: number;
  date: string;
  yesterday_summary: string | null;
  weather_data: WeatherData | null;
  calendar_data: CalendarEntry[] | null;
  daily_tasks: DailyTask[];
  created_at: string;
  isCurrent: boolean;
}

export interface WeatherData {
  temperature: number;
  condition: string;
  location: string;
}

export interface CalendarEntry {
  time: string;
  title: string;
  duration?: number;
}

export interface DailyTask {
  title: string;
  description: string;
  source_goal: string;
  project_assignment: string | null;
  priority: string;
  estimated_minutes?: number;
}

export interface GoalBreakdown {
  id: number;
  level: string;
  title: string;
  description: string | null;
  source_goal: string | null;
  project_assignment: string | null;
  priority: string;
  status: string;
  parent_breakdown_id: number | null;
  created_at: string;
  updated_at: string;
}

export async function getMorningCheck(): Promise<MorningCheckResponse> {
  return fetchJson<MorningCheckResponse>(`${BREAKDOWN_URL}/morning-check`);
}

export async function getMonthlyBreakdowns(): Promise<GoalBreakdown[]> {
  return fetchJson<GoalBreakdown[]>(`${BREAKDOWN_URL}/monthly`);
}

export async function getWeeklyBreakdowns(): Promise<GoalBreakdown[]> {
  return fetchJson<GoalBreakdown[]>(`${BREAKDOWN_URL}/weekly`);
}

export async function triggerDailyCheck(): Promise<{ status: string; type: string }> {
  return fetchJson<{ status: string; type: string }>(`${BREAKDOWN_URL}/trigger/daily`, {
    method: 'POST',
  });
}
